import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { colorWhite } from '@spark/ui-components/theme';
import { Button } from '@spark/ui-components/components/Button';

const NotFound404 = () => {
  const history = useHistory();
  useEffect(() => {
    const timer = setTimeout(() => {
      history.goBack();
    }, 5000);
    return () => clearTimeout(timer);
  }, [history]);
  return <NotFoundContainer>
      <Content>
        <Image src={`${process.env.PUBLIC_URL}/img/404/404.png`} alt="404 Página não encontrada" />
        <Info style={{
        color: "black"
      }}>Ooops! A página que você está procurando não foi encontrada :(</Info>
        <Button variant="primary" onClick={() => history.goBack()}>
          Voltar
        </Button>
      </Content>
    </NotFoundContainer>;
};

export default NotFound404; // ——————— STYLES ———————

const NotFoundContainer = styled.div`
  text-align: center;
  height: 100vh;
  overflow: auto;
  display: flex;
  background: url(${process.env.PUBLIC_URL}/img/404/bg_404.jpeg) no-repeat center;
  background-size: cover;

  button {
    margin-top: 20px;
  }
`;
const Content = styled.div`
  margin: auto;
  padding: 10px;
`;
const Image = styled.img`
  max-width: 500px;
  width: 100%;
`;
const Info = styled.h3`
  color: ${colorWhite};
  margin: 40px 0 20px;
`;
